export const css = {
	root: '_3YTMPE6s',
	inputWrapper: 'Wxdu8YoA',
	filled: '_1eseqYas',
	thumb: 'jp_yWdT5',
	input: 'VKeZp6sS',
	focused: '_28vL2nXv',
	hasOutput: 'QORMJE-B',
	outputTooltip: '_19xMOkSN',
	output: '_1Fj1Pax6',
	disabled: '_3lTQ_i69',
	readonly: '_2GxMcjTj',
	invalid: '_3-06_ga-',
	' _key': 'afcpe-theme/dojo/range-slider'
};

export default css;
